export function formatISODateRepresentationDate(date: Date | number, locale?: string, joinSign = '-') {
  // Previously used date-fns has different way to format dates.
  // In order to keep same formats date is formatted to separate parts
  const datePartsList = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  // From array of parts we get rid of `literal`s (which are joining chars, like '-', '/' etc.) and create a map.
  const datePartsMap = datePartsList.reduce((acc, element) => {
    const type = element.type as string;
    if (type !== 'literal') {
      acc[type] = element.value;
    }
    return acc;
  }, {} as Record<string, string | number>);

  // Return date in proper format with proper join sign.
  return [datePartsMap.year, datePartsMap.month, datePartsMap.day].join(joinSign);
}
